import * as React from "react";
import { cva } from "class-variance-authority";

// Port of shadcn's Button — same cva variant API, minus @radix-ui/react-slot's `asChild`
// polymorphism (not needed here; a plain <button> is fine). No cn() helper either — see
// flag in the PR/commit notes: with only cva's own single variant string plus an optional
// external className, plain template-literal concatenation is enough; clsx + tailwind-merge
// would only earn their keep once callers start passing conflicting utility classes in from
// outside this file, which nothing here does yet.
const buttonVariants = cva(
  "appearance-none inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
  const classes = `${buttonVariants({ variant, size })}${className ? ` ${className}` : ""}`;
  return <button className={classes} ref={ref} {...props} />;
});
Button.displayName = "Button";

export { Button, buttonVariants };
